module.exports = __webpack_public_path__ + "static/media/excel.683fa254.svg";